import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[25px] mb-[25px]" }
const _hoisted_2 = {
  key: 0,
  class: "col-span-full text-center py-8"
}
const _hoisted_3 = { class: "mt-4 text-gray-600 dark:text-gray-300" }
const _hoisted_4 = {
  key: 1,
  class: "col-span-full text-center py-8"
}
const _hoisted_5 = { class: "text-gray-600 dark:text-gray-300" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = { class: "block rounded-md aspect-square" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "mt-[19px]" }
const _hoisted_12 = { class: "text-md font-normal" }
const _hoisted_13 = { class: "transition-all hover:text-primary-500" }
const _hoisted_14 = { class: "flex items-center justify-between mt-[12px] md:mt-[20px] lg:mt-[28px]" }
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = { class: "block font-bold text-black dark:text-white text-[20px]" }
const _hoisted_17 = {
  key: 0,
  class: "block text-md text-gray-400 ltr:ml-[7px] rtl:mr-[7px]"
}
const _hoisted_18 = {
  key: 0,
  class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md"
}
const _hoisted_19 = { class: "trezo-card-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-primary-500 border-r-transparent" }, null, -1)),
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.directT('ecommerce.productsGrid.loadingProducts')), 1)
          ]))
        : (_ctx.products.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.directT('ecommerce.productsGrid.noProductsFound')), 1)
            ]))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.products, (product) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "md:mb-[10px] lg:mb-[17px] bg-white dark:bg-[#0c1427] p-5 rounded-xl shadow-sm cursor-pointer",
                key: product.id,
                onClick: ($event: any) => (_ctx.navigateToEdit(product.id))
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "block ltr:right-0 rtl:left-0 bottom-0 w-[65px] h-[65px] absolute ltr:rounded-tl-md rtl:rounded-tr-md bg-white dark:bg-[#0c1427]" }, null, -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: product.image_link,
                      alt: product.title,
                      class: "rounded-md w-full h-full object-cover"
                    }, null, 8, _hoisted_9)
                  ]),
                  _createElementVNode("a", {
                    href: product.product_link,
                    target: "_blank",
                    class: "rounded-md transition-all z-[1] inline-flex items-center justify-center absolute ltr:right-0 rtl:left-0 bottom-0 w-[60px] h-[60px] bg-primary-500 text-white hover:bg-primary-400",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                  }, _cache[2] || (_cache[2] = [
                    _createElementVNode("i", { class: "material-symbols-outlined" }, " shopping_cart ", -1)
                  ]), 8, _hoisted_10)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("h6", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(product.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.formatPrice(product.compare_at_price || product.price)), 1),
                      (product.compare_at_price)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.formatPrice(product.price)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ], 8, _hoisted_6))
            }), 128))
    ]),
    (_ctx.products.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_Pagination, {
              items: _ctx.pageSize,
              total: _ctx.totalProducts,
              current: _ctx.currentPage,
              onPageChange: _ctx.handlePageChange,
              class: "pt-[0] md:pt-[0]"
            }, null, 8, ["items", "total", "current", "onPageChange"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}